import { createContext } from "react";
import type { DashboardApiStatusContextType } from "./DashboardApiStatusContext.types";

const DashboardApiStatusContext = createContext<DashboardApiStatusContextType | undefined>(undefined);
DashboardApiStatusContext.displayName = "DashboardApiStatusContext";

export default DashboardApiStatusContext;
